import ossUpload from "@/utils/alioss";

class SrmUploadService {
  private static instance: SrmUploadService;

  private constructor() {}

  public static getInstance() {
    if (!SrmUploadService.instance) {
      SrmUploadService.instance = new SrmUploadService();
    }
    return SrmUploadService.instance;
  }

  private async ossUpload(file: File, customFileName?: string) {
    // 每个文件上传前都重新获取STS凭证，以获得新的上传路径
    await ossUpload.getSTSCredentials();

    const fileName = customFileName ? `/${customFileName}` : `/${file.name}`;
    const result = await ossUpload.upload(
      file,
      fileName,
      () => {}, // (progress: number) => console.log(progress)
    );

    return result.url;
  }

  /**
   *
   * @param file 文件对象
   * @param (option) 自定义文件名
   * @returns 文件地址
   */
  public uploadFile(file: File, customFileName?: string): Promise<string> {
    console.log(file, customFileName);
    return this.ossUpload(file, customFileName);
  }
}

export const srmUploadService = SrmUploadService.getInstance();
